import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTenantNavigation } from '../../hooks/useTenantNavigation';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import imgLutenteNav from '../../assets/images/LutenteNavTransparent.png';

const ClientePagoResultado = () => {
  const [searchParams] = useSearchParams();
  const navigate = useTenantNavigation();
  const [countdown, setCountdown] = useState(5);

  const status = searchParams.get('status');
  const paymentId = searchParams.get('payment_id');
  const externalReference = searchParams.get('external_reference');

  useEffect(() => {
    // Auto-redirect después de 5 segundos
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          handleVolver();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleVolver = () => {
    // Redirigir a dashboard de cliente
    navigate('mispagos/dashboard');
  };

  const renderContent = () => {
    switch (status) {
      case 'success':
        return {
          icon: <CheckCircleIcon sx={{ fontSize: 80, color: 'success.main' }} />,
          title: '¡Pago Exitoso!',
          message: 'Tu pago fue procesado correctamente. En unos segundos verás tu cuota actualizada.',
          color: 'success.main',
          bgColor: 'success.lighter'
        };
      
      case 'pending':
        return {
          icon: <HourglassEmptyIcon sx={{ fontSize: 80, color: 'warning.main' }} />,
          title: 'Pago Pendiente',
          message: 'Tu pago está siendo procesado. Te notificaremos cuando se acredite.',
          color: 'warning.main',
          bgColor: 'warning.lighter'
        };
      
      case 'failure':
        return {
          icon: <ErrorIcon sx={{ fontSize: 80, color: 'error.main' }} />,
          title: 'Pago Rechazado',
          message: 'No pudimos procesar tu pago. Puedes intentar nuevamente con otro medio de pago.',
          color: 'error.main',
          bgColor: 'error.lighter'
        };
      
      default:
        return {
          icon: <HourglassEmptyIcon sx={{ fontSize: 80, color: 'info.main' }} />,
          title: 'Procesando...',
          message: 'Estamos verificando tu pago.',
          color: 'info.main',
          bgColor: 'info.lighter'
        };
    }
  };

  const content = renderContent();

  return (
    <Box 
      sx={{ 
        minHeight: '100vh', 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2
      }}
    >
      {/* Logo */}
      <Box sx={{ mb: 4 }}>
        <img 
          src={imgLutenteNav} 
          alt="Lutente" 
          style={{ height: '60px' }}
        />
      </Box>

      {/* Contenido */}
      <Container maxWidth="sm">
        <Paper 
          elevation={8} 
          sx={{ 
            p: 4, 
            textAlign: 'center',
            borderRadius: '24px',
            backgroundColor: 'white'
          }}
        >
          <Box sx={{ mb: 3 }}>
            {content.icon}
          </Box>

          <Typography 
            variant="h4" 
            gutterBottom 
            sx={{ color: content.color, fontWeight: 'bold' }}
          >
            {content.title}
          </Typography>

          <Typography 
            variant="body1" 
            color="text.secondary" 
            sx={{ mb: 3, lineHeight: 1.6 }}
          >
            {content.message}
          </Typography>

          {paymentId && (
            <Box 
              sx={{ 
                bgcolor: 'grey.100', 
                p: 2, 
                borderRadius: '12px', 
                mb: 3 
              }}
            >
              <Typography variant="caption" color="text.disabled" display="block">
                ID de Operación
              </Typography>
              <Typography variant="body2" fontWeight="bold" color="text.secondary">
                {paymentId}
              </Typography>
            </Box>
          )}

          <Box sx={{ mt: 4 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleVolver}
              size="large"
              fullWidth
              sx={{
                borderRadius: '12px',
                textTransform: 'none',
                py: 1.5,
                fontSize: '1.1rem',
                fontWeight: 'bold'
              }}
            >
              Volver a Mis Paquetes
            </Button>
          </Box>

          <Typography 
            variant="caption" 
            color="text.disabled" 
            sx={{ mt: 2, display: 'block' }}
          >
            Serás redirigido automáticamente en {countdown} segundo{countdown !== 1 ? 's' : ''}...
          </Typography>
        </Paper>
      </Container>

      {/* Footer */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="body2" color="white" sx={{ opacity: 0.8 }}>
          © {new Date().getFullYear()} Lutente Tours. Todos los derechos reservados.
        </Typography>
      </Box>
    </Box>
  );
};

export default ClientePagoResultado;





